export { default } from './CollectionImage';
